import { WorkspaceListItem } from 'shared';

import { BackendRoute } from '../../../config/index';
import { QueryKey } from '../../../constants/index';
import { useAppQuery } from '../../../hooks/use-app-query.hook';
import { ApiService } from '../../../services/index';
import { selectedCompanyStorage } from '../../../storage/company/selected-company.util';

// One workspace with its description, which neither the sidebar nor the open space carries.
export const useWorkspace = (id: string | undefined) => {
  // Only keys the cache: the route takes the company from the session.
  const companyId = selectedCompanyStorage(({ companyId: selected }) => selected);

  const { data, isPending } = useAppQuery({
    queryKey: [QueryKey.GET_WORKSPACE, companyId, id],
    queryFn: () =>
      ApiService.get<WorkspaceListItem>({ endpoint: BackendRoute.WORKSPACES, routePath: [id!] }),
    enabled: Boolean(companyId && id),
  });

  return { isPending, workspace: data };
};
